import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Avatar } from '@ibk/shared-ui';
export const BankLogoAvatar = ({ externalBankImageUrl, fallbackLogo, className, testId, institutionName, }) => {
    const avatarSrc = externalBankImageUrl && externalBankImageUrl !== '' ? externalBankImageUrl : fallbackLogo;
    if (avatarSrc) {
        return (_jsx(Avatar, { src: avatarSrc, type: 'image', className: className, "data-testid": `avatarBankAccountListLogo${testId ?? ''}` }));
    }
    return (_jsx(Avatar, { type: 'inicial', className: className, "data-testid": `avatarBankAccountListInitial${testId ?? ''}`, initials: institutionName?.slice(0, 2).toUpperCase() ?? '' }));
};
